// import React from 'react';
import '../css/photos.scss';
// import { Link } from 'react-router-dom';

const Photos = () => {

  return (
    <div id="photos">
      <div id="title">
        <h1>Photos</h1>
      </div>
      <div id="content">
        <div className='flex flex-wrap'>
          <img className="h" alt='Duo Tamba 1' src='/images/creacirque/image0.jpeg' />
          <img className="h" alt='Duo Tamba 2' src='/images/creacirque/image1.jpeg' />
          <img className="v" alt='Duo Tamba 3' src='/images/creacirque/tamba1.jpg' />
          <img className="v" alt='Duo Tamba 4' src='/images/creacirque/image3.jpeg' />
          <img className="v" alt='Duo Tamba 5' src='/images/creacirque/image4.jpeg' />
          <img className="v" alt='Duo Tamba 6' src='/images/creacirque/image5.jpeg' />
          <img className="h" alt='Duo Tamba 7' src='/images/creacirque/tamba2.jpg' />
          <img className="h" alt='Duo Tamba 8' src='/images/animations/duotamba1.jpg' />
          <img className="h" alt='Duo Tamba 9' src='/images/creacirque/tamba3.jpg' />
          <img className="h" alt='grimage 1' src='/images/animations/grimage1.jpg' />
          <img className="h" alt='grimage 2' src='/images/animations/grimage2.jpg' />
          <img className="h" alt='grimage 3' src='/images/animations/grimage3.jpg' />
          <img className="h" alt='grimage 4' src='/images/animations/grimage4.jpg' />
          <img className="h" alt='grimage 5' src='/images/animations/grimage5.jpg' />
          <img className="h" alt='grimage 6' src='/images/animations/grimage6.jpg' />
          <img className="h" alt='grimage 7' src='/images/animations/grimage7.jpg' />
          <img className="h" alt='grimage 8' src='/images/animations/grimage8.jpg' />
          <img className="h" alt='grimage 9' src='/images/animations/grimage9.jpg' />
          <img className="h" alt='espace cirque 2' src='/images/animations/espace_cirque2.jpg' />
          <img className="h" alt='espace cirque 3' src='/images/animations/espace_cirque3.jpg' />
          <img className="h" alt='espace cirque 4' src='/images/animations/espace_cirque4.jpg' />
          <img className="h" alt='sculpture de ballons' src='/images/animations/espace_cirque1.jpg' />
          <img className="h" alt='echassiers' src='/images/animations/jonglerie1.jpg' />
          <img className="h" alt='jonglerie' src='/images/animations/jonglerie3.jpeg' />
        </div>
        <div>
          <img className="v" alt='spectacle' src='/images/spectacle/spectacle.jpg' />
          <img className="v" alt='stage' src='/images/stages/cours-stage.jpg' />
        </div>
        {/* <div>
          <img className="h" alt='didier 1' src='/images/spectacle/didier1.jpg' />
          <img className="h" alt='didier 2' src='/images/spectacle/didier2.jpg' />
          <img className="h" alt='didier 3' src='/images/spectacle/didier3.jpg' />
          <img className="h" alt='didier 4' src='/images/spectacle/didier4.jpg' />
        </div> */}
      </div>
    </div>
  )
};

export default Photos;
